"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLocationAddress = exports.StyledLocationName = exports.StyledLocation = exports.ProviderAvailabilityContainer = exports.ProviderSpecialtiesMoreAnchor = exports.ProviderCompactFirstSpecialty = exports.ProviderSpecialtiesCompactContainer = exports.ProviderSpecialtiesContainer = exports.ProviderNameLinkContainer = exports.ProviderNameContainer = exports.ProviderImage = exports.ImageWrapper = exports.ImageWrapperWithEnhancement = exports.ContentWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const image_component_1 = __importDefault(require("@kyruus/image-component"));
const PROVIDER_IMAGE_WIDTH_HEIGHT = '50px';
const PROVIDER_IMAGE_MAX_WIDTH = '100%';
/**
 * This snippet will truncate the content and render an ellipsis (...) if
 * the content does not fit on a single line.
 * If the browser supports line-clamping, we can extend this to two lines.
 */
const truncateWithEllipsisStyles = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
exports.ContentWrapper = (0, styled_1.default)('div') `
  display: grid;
  grid-template-areas: 'image name' 'image specialty' 'image location' 'image availability';
  grid-auto-rows: minmax(min-content, 0);
  grid-template-columns: max-content minmax(0, 1fr);
  row-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  width: 100%;
  height: 100%;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.ImageWrapperWithEnhancement = (0, styled_1.default)('div') `
  grid-area: image;

  img {
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  }
`;
exports.ImageWrapper = (0, styled_1.default)('div') `
  grid-area: image;
  height: ${PROVIDER_IMAGE_WIDTH_HEIGHT};
  width: ${PROVIDER_IMAGE_WIDTH_HEIGHT};
  overflow: hidden;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  background: ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  border-radius: ${(0, ui_theme_1.fromTheme)('alt_provider_profile_image_border_radius')};
`;
exports.ProviderImage = (0, styled_1.default)(image_component_1.default) `
  display: block;
  max-width: ${({ enabledEnhancement }) => enabledEnhancement ? 'unset' : PROVIDER_IMAGE_WIDTH_HEIGHT};
  width: ${({ enabledEnhancement }) => enabledEnhancement ? '48px' : PROVIDER_IMAGE_MAX_WIDTH};
  height: ${({ enabledEnhancement }) => (enabledEnhancement ? '48px' : 'auto')};

  @media only screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    max-width: ${({ enabledEnhancement }) => enabledEnhancement ? 'unset' : '90px'};
  }
`;
exports.ProviderNameContainer = (0, styled_1.default)('div') `
  grid-area: name;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};

  ${truncateWithEllipsisStyles};
`;
exports.ProviderNameLinkContainer = (0, styled_1.default)('a') `
  grid-area: name;
  cursor: pointer;
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  text-decoration: none;
  ${truncateWithEllipsisStyles};

  &:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }

  &:hover,
  &:hover:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_link_hover')};
    text-decoration: underline;
  }
`;
exports.ProviderSpecialtiesContainer = (0, styled_1.default)('div') `
  grid-area: specialty;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
  ${truncateWithEllipsisStyles};
`;
exports.ProviderSpecialtiesCompactContainer = (0, styled_1.default)('div') `
  display: flex;
  flex: auto;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.ProviderCompactFirstSpecialty = (0, styled_1.default)('div') `
  padding-left: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.ProviderSpecialtiesMoreAnchor = (0, styled_1.default)('div') `
  white-space: nowrap;
  & > span {
    padding-bottom: 1px;
    cursor: pointer;
    display: inline-block;
    border-bottom: 1px dotted;
  }

  &::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    height: 2px;
    width: 2px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;
exports.ProviderAvailabilityContainer = (0, styled_1.default)('div') `
  grid-area: availability;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
  color: ${(0, ui_theme_1.fromTheme)('color_icon_green')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    display: inline;
    vertical-align: middle;
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  }

  span {
    vertical-align: middle;
  }
`;
exports.StyledLocation = styled_1.default.div `
  grid-area: location;
`;
exports.StyledLocationName = styled_1.default.h5 `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.StyledLocationAddress = styled_1.default.p `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
//# sourceMappingURL=MiniProviderContent.styles.js.map